import { colors } from '@service-victoria/component-library/utils';
import styled from 'styled-components';

export const Wrapper = styled.div`
  ul {
    color: ${colors.blueGrey};

    li {
      margin: 5px 0;

      &:first-of-type {
        margin-top: 0;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  ol {
    &,
    & > li {
      margin: 5px 0;
      list-style: numeric;

      &:first-of-type {
        margin-top: 0;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  & ol:first-of-type {
    &,
    & > li {
      margin: 5px 0;
      list-style: lower-alpha;

      &:first-of-type {
        margin-top: 0;
      }

      &:last-of-type {
        margin-bottom: 0;
      }

      > ol {
        &,
        & > li {
          list-style: lower-roman;
        }
      }
    }
  }
`;

export const Spacer16 = styled.div`
  margin-top: 16px;
`;
